import React from 'react';

const traitIcons = {
  'Aerobic': '🫁',
  'Anaerobic': '🦠',
  'Gram+': '🔵',
  'Gram-': '🟣',
};

const traitColors = {
  'Aerobic': '#60A5FA',
  'Anaerobic': '#F87171',
  'Gram+': '#A3E635',
  'Gram-': '#a78bfa',
};

export default function ForTheGramSiteInfoCard() {
  return (
    <div
      className="rounded-xl shadow-md p-5 mb-4"
      style={{
        background: 'linear-gradient(120deg, #FEF9C3 90%, #FDE68A 100%)',
        border: '1.5px solid #FDE68A',
        minWidth: 260,
        maxWidth: 320,
        color: '#444',
        fontFamily: 'inherit',
      }}
    >
      <div className="font-bold text-lg mb-2" style={{ color: '#b45309', letterSpacing: '0.01em' }}>For the Gram</div>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>ATTRIBUTES</div>
      <ul className="mb-3 text-sm">
        <li><span className="font-medium">ThermalTolerance:</span> <span style={{ color: '#2563eb' }}>6 – 9</span></li>
        <li><span className="font-medium">pHTolerance:</span> <span style={{ color: '#2563eb' }}>5 – 8</span></li>
        <li><span className="font-medium">Motility:</span> <span style={{ color: '#2563eb' }}>3 – 6</span></li>
      </ul>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>TRAITS</div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Desired:</span>{' '}
        <span style={{ color: traitColors['Aerobic'], fontWeight: 600 }}>
          {traitIcons['Aerobic']} Aerobic
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Undesired:</span>{' '}
        <span style={{ color: traitColors['Anaerobic'], fontWeight: 600 }}>
          {traitIcons['Anaerobic']} Anaerobic
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">All traits:</span>{' '}
        {['Aerobic', 'Anaerobic', 'Gram+', 'Gram-'].map(trait => (
          <span key={trait} style={{ color: traitColors[trait], marginRight: 8, fontWeight: 600 }}>
            {traitIcons[trait]} {trait}
          </span>
        ))}
      </div>
    </div>
  );
} 